












































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'

import PricingTable from '@ui/Event/PricingTable'
import UpdatePricingModelTriggerModal from '@triggers/Event/UpdatePricingModelTriggerModal'

import AddPartnerBrandRepTriggerModal from '@ui/triggers/AudiencePartnership/AddPartnerBrandRepTriggerModal'
import RemovePartnerBrandRepTriggerModal from '@ui/triggers/AudiencePartnership/RemovePartnerBrandRepTriggerModal'


settings =
  name: 'AudiencePartnershipShow'

  resources:
    item:
      resourceName: 'audience_partnership'
      slug: 'audience_partnerships/:audiencePartnershipId'


  vue:
    components: { SuperContainerView, Back, PricingTable, UpdatePricingModelTriggerModal, AddPartnerBrandRepTriggerModal, RemovePartnerBrandRepTriggerModal }

    props: ['audiencePartnershipId']

    data: ->
      CsvLinks: ""

    computed:
      topOrgName: ->
        @item.supplier.top_org?.name || @item.supplier.name

      partnerBrandRepEmails: -> @item?.partner_brand_reps || []

      actionsForPricingModel: ->
        {
          @hiUpdatePricingModelTrigger,
          @hiRemoveSpecialPricingTrigger
        }

      audienceListings: -> @item.share_links || []

    methods:
      hiAddPartnerBrandRepTrigger: ->
        @$refs.addPartnerBrandRepTrigger.fire()
      onItemAddPartnerBrandRep: ->
        @$refs.addPartnerBrandRepTrigger.close()

      hiRemovePartnerBrandRepTrigger: (email) ->
        payloadOptions = { email: email }
        @$refs.removePartnerBrandRepTrigger.fire(payloadOptions)
      onItemRemovePartnerBrandRep: ->
        @$refs.removePartnerBrandRepTrigger.close()

      hiUpdatePricingModelTrigger: (pricingModel, pricing) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, pricing }
        @$refs.updatePricingModelTrigger.fire(payloadOptions, modalOptions)
      hiRemoveSpecialPricingTrigger: (pricingModel) ->
        @triggerResource 'item', 'update_pricing_model', { pricing_model: pricingModel }
      onItemUpdatePricingModel: (data, response) ->
        @$refs.updatePricingModelTrigger.close()
        @fetch('item')

      hiCopytoClipboard: (ev, listing) ->
        shareLink = listing.link
        shareLinkPath = "#{window.location.origin}/#{shareLink}"
        @copyToClipboard ev, shareLinkPath
        @showFlash { 'Message:': 'Copied to clipboard' }

      replaceComma: (string) ->
        string.replace(/,/, " -")

      convertCreativeToCSV: () ->
        @CsvLinks = ""
        @audienceListings.forEach( (listing) => (
          shareLink = listing.link
          shareLinkPath = "#{window.location.origin}/#{shareLink}"
          csvString = "#{@replaceComma(listing.organizer)}, #{@replaceComma(listing.supplier)}, #{@replaceComma(listing.name)}, #{@replaceComma(listing.location)}, #{shareLinkPath}\n"
          @CsvLinks = @CsvLinks.concat(csvString)))

      hiExportAllLinksCsvToClipboard: (ev) ->
        @convertCreativeToCSV()
        @copyToClipboard ev, @CsvLinks
        @showFlash { 'Message:': 'Copied to clipboard' }



export default VueOptions.vue settings
